var map = {
	"./auth.js": "c7d4",
	"./basket.js": "aa2d",
	"./brands.js": "7667",
	"./chats.js": "f47e",
	"./clients.js": "1171",
	"./csDirectories.js": "ec20",
	"./csPrices.js": "e47a",
	"./dealerBuyers.js": "22fc",
	"./dealerBuyersReports.js": "1167",
	"./dealers.js": "6d5f",
	"./details.js": "c311",
	"./exports.js": "b78a0",
	"./loyaltyLevels.js": "85ca",
	"./news.js": "611b",
	"./orders.js": "d001",
	"./orderscrud.js": "b2ed",
	"./payment.js": "9465",
	"./prices.js": "c63b",
	"./promotions.js": "326a",
	"./reportDealers.js": "9a65",
	"./reportDynamic.js": "7304",
	"./reportDynamicGroup.js": "54e9",
	"./reportPeriod.js": "9101",
	"./reportPeriodGroup.js": "de47",
	"./suppliers.js": "55df"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c3e1";